import { connect } from 'react-redux';
import {
  actionClearLandmarkList,
  actionGetLandmarkList,
} from 'store/landmark/action';

import StepBasic from './StepBasic';

const mapStateToProps = (state) => ({
  setting: state.Setting.setting,
  landmarkOptions: state.Landmark.landmarkOptions,
  isLoadingLandmarkList: state.Landmark.isLoadingLandmarkList,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetLandmarkList: (payload) => dispatch(actionGetLandmarkList(payload)),
  actionClearLandmarkList: () => dispatch(actionClearLandmarkList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(StepBasic);
